import axios from "axios";
const encApi = axios.create({
  baseURL: "https://2oohad50vh.execute-api.us-west-2.amazonaws.com/v1"
});
//Both URL should be same
export const url = "https://2oohad50vh.execute-api.us-west-2.amazonaws.com/v1";
 
export default encApi;